import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate, Outlet } from "react-router-dom";
import axios from "../common/axios";
import { Circles } from "react-loader-spinner";
import { useSetRecoilState } from "recoil";
import { userState } from "./atom/userState";

const checkSession = async () => {
  try {
    const response = await axios.post(
      `/loa_is_logged_in`,
      {},
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    console.log("[session check]", response.data);
    return {
      isValidSession: response.data.isLoggedIn,
      expiresIn: response.data.expiresIn,
      username: response.data.username,
      name: response.data.name,
    };
  } catch (error) {
    console.error("Error verifying session:", error);
    return { isValidSession: false };
  }
};

const ProtectedRoute = ({ children }) => {
  const [isValidSession, setIsValidSession] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const setUser = useSetRecoilState(userState);

  useEffect(() => {
    const fetchData = async () => {
      const validity = await checkSession();
      if (!validity.isValidSession) {
        const redirectTo = location.pathname + location.search;
        navigate(`/login?redirect=${encodeURIComponent(redirectTo)}`, { replace: true });
      }

      setIsValidSession(validity.isValidSession);
      setUser((prev) => {
        return {
          ...prev,
          isLoggedIn: validity.isValidSession,
          expiresIn: validity?.expiresIn ?? null,
          username: validity?.username ?? prev.username,
          name: validity?.name ?? prev.name,
        };
      });
      setIsLoading(false);
    };
    fetchData();
  }, [location]);

  if (isLoading) {
    return (
      <div className="loadingContainer">
        <Circles ariaLabel="loading" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }

  return isValidSession ? <Outlet /> : <Outlet />;
};

export default ProtectedRoute;
